module.exports = __webpack_public_path__ + "img/image-photon.95ec102f.jpg";